import routerOptions0 from "/var/www/share/mysofabed.de/app/node_modules/.pnpm/nuxt@3.17.5_@biomejs+biome@1.8.3_@parcel+watcher@2.5.1_@types+node@22.15.23_db0@0.3.2_e_da87fc9f9e0427cb820d26493b88beaa/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/var/www/share/mysofabed.de/app/app/router.options.ts";
const configRouterOptions = {
  linkActiveClass: "link-active",
  linkExactActiveClass: "link-exact-active text-primary",
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}